import { FC } from "react";

import MenuGroup from "../Menu/MenuGroup";
import MenuGroupItem from "../Menu/MenuGroupItem";
import { usePathname } from "../../navigation";
import Image from "next/image";
import useTracking from "../Hooks/useTracking";

const SupportSidebarMenu: FC = ({ navigation }) => {
  const pathname = usePathname() ?? "";
  const { navigate } = useTracking();
  return (
    <div className="flex flex-col w-full overflow-auto text-left transition-all bg-white rounded dark:bg-tertiary-700 text-tertiary dark:text-white">
      <MenuGroup className={"gap-2 "}>
        {navigation?.map((item, index) => {
          console.log("item--item--", item);

          return (
            <MenuGroupItem
              href={item?.path ?? "/support"}
              active={pathname === item?.path}
              key={`${index}__SupportSidebarMenu`}
              onClick={() => {
                navigate(`${item?.path ?? "/support"}`, {
                  component: "SupportSidebarMenu",
                  isMobileOrTablet: "No",
                  label: item?.title,
                  navigateFrom: "Help Center Menu",
                });
              }}
            >
              {item?.icon && (
                <Image
                  width={20}
                  height={20}
                  src={item?.icon}
                  alt=""
                  className="block mx-auto  "
                  loading="lazy"
                />
              )}
              <div> {item?.title}</div>
            </MenuGroupItem>
          );
        })}
      </MenuGroup>
    </div>
  );
};

export default SupportSidebarMenu;
